import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";
import property from "lodash/property";

const wishListUrl = "/api/v1/wishlists";

export interface AddWishListApiParameter extends ApiParameter {
    properties: any;
    name?: string;
    description?: string;
    branchName?: string;
}
export function CustomaddWishList(parameter: AddWishListApiParameter) {
    return post<WishListModel>(wishListUrl, {
        name: parameter.name,
        description: parameter.description,
        properties: {
            branchName: parameter.properties.branchName,
        },
    } as unknown as WishListModel);
}
